module.exports = __webpack_public_path__ + "2df56ec8501d08334f591b8167bb4ddc.MP3";